module.exports = tatum_utils;